import React, { useEffect } from "react";
import { navigate } from "@reach/router";
import { useUser } from "../../hooks/useApi";
import { getEntryIntent, getRadioEntryPath } from "./entryIntentStorage";
import EntryFlowGate from "./EntryFlowGate";

export default function EntryAuthGuard({ children }) {
  const { logged, initiated } = useUser();
  const intent = getEntryIntent();
  const resumePath = getRadioEntryPath();
  const mustResume =
    initiated &&
    !logged &&
    !!resumePath &&
    (window.location.pathname === "/" ||
      !intent ||
      !["login", "none", "error"].includes(intent.terms?.status));
  useEffect(() => {
    if (mustResume) navigate(resumePath, { replace: true });
  }, [mustResume, resumePath]);
  return mustResume ? <EntryFlowGate /> : children;
}
